var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab',{attrs:{"to":_vm.route}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }